export enum PaginationConfig {
  TAGS_MAX_RESULT = 20,
  CATEGORIES_MAX_RESULT = 20,
  BUSINESSUNIT_AND_DIVISION_MAX_RESULT = 20,
  LOCATIONS_MAX_RESULT = 20,
  PERMISSIONS_MAX_RESULT = 20,
  USERS_MAX_RESULT = 20,
  TEMPLATES_MAX_RESULT = 20,
  QUESTIONS_MAX_RESULT = 20,
  SCHEDULE_MAX_RESULT = 20,
  TASKS_MAX_RESULT = 20,
  AUDIT_MAX_RESULT = 20,
}
